// extracted by mini-css-extract-plugin
module.exports = {"linksCard":"index-module--linksCard--1otbo","linkItem":"index-module--linkItem--15H2R","linkItem2":"index-module--linkItem2--1ULbb"};